import { render, staticRenderFns } from "./gateway-cards.vue?vue&type=template&id=1a8cbd80"
import script from "./gateway-cards.vue?vue&type=script&lang=js"
export * from "./gateway-cards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports